<ng-container *ngIf="!!value">
  <app-label [label]="label">
    <div tuiGroup [collapsed]="true">
      <tui-input
        [ngModel]="value.title"
        [focusable]="focusable"
        [disabled]="disabled"
        [readOnly]="readOnly"
        [tuiTextfieldSize]="'m'"
        [pseudoInvalid]="computedInvalid"
        [tuiTextfieldLabelOutside]="true"
        (focusedChange)="onFocused($event)"
        (ngModelChange)="onValueChange($event)"
      >
        <ng-content></ng-content>
        <input tuiTextfieldLegacy type="text" />
      </tui-input>

      <button
        *ngIf="showVisibilityOption"
        tuiIconButton
        class="tui-group__auto-width-item"
        type="button"
        [size]="'m'"
        [appearance]="'textfield'"
        [tuiDropdown]="showFor"
        [tuiDropdownAlign]="'left'"
        [tuiDropdownManual]="open"
        [tuiDropdownMobile]="value.title!"
        (click)="open = !open"
        (tuiActiveZoneChange)="activeZoneChange($event)"
      >
        <app-icon class="icon" [src]="'@tui.eye'" size="16px"></app-icon>
      </button>
    </div>

    <div *ngIf="showVisibilityOption" class="visibility-hint">{{ visibility | translate }}</div>

    <ng-template #showFor>
      <tui-data-list [size]="'s'">
        <tui-opt-group [label]="'components.customName.constants.visibilityOptions.title' | translate">
          <button
            *ngFor="let visibility of visibilities"
            tuiOption
            class="visibility-item"
            [value]="visibility.value"
            (click)="changeVisibility(visibility.value)"
          >
            {{ visibility.name | translate }}
            <app-icon
              *ngIf="visibility.value === value.visibilityOption"
              class="visibility-item__icon"
              [src]="'@tui.check'"
              size="16px"
            ></app-icon>
          </button>
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  </app-label>
</ng-container>
